import React from 'react'
import ReactDOM from 'react-dom/client'
import LessonListContainer from './lesson-list'
import { store } from '../../store'
import { Provider } from 'react-redux'

function Wrapper(props) {
  return (
      <Provider store={store}>
          <LessonListContainer {...props}/>
      </Provider>
  )
}

function initLessonListContainer(element) {
  var options = element.dataset;
  var root = ReactDOM.createRoot(element);
  root.render(React.createElement(Wrapper, options));
}

document.addEventListener("DOMContentLoaded", function() {
  var elements = document.querySelectorAll('[data-lesson-list]');
  elements.forEach(initLessonListContainer);
});
